"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DangerIcon = DangerIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function DangerIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 54 54"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.0535 4.90967C34.0295 4.9097 44.151 9.69696 44.1511 21.7339C44.1511 35.1935 32.5249 44.5774 27.0535 49.0913C21.1717 44.9422 9.81812 34.0993 9.81812 21.7339C9.81821 9.8337 20.0774 4.90967 27.0535 4.90967ZM27.2166 8.7749C20.4555 8.7749 14.9746 14.2561 14.9744 21.0171C14.9744 27.7783 20.4553 33.2603 27.2166 33.2603C33.9776 33.2601 39.4587 27.7782 39.4587 21.0171C39.4585 14.2562 33.9775 8.77511 27.2166 8.7749Z",
    fill: "#F260A7"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    height: "46",
    id: "mask0_5587_13299",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'alpha'
    },
    width: "36",
    x: "9",
    y: "4"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.81836 21.734C9.81836 34.0994 21.1716 44.9419 27.0533 49.091C32.5248 44.5771 44.1515 35.1937 44.1515 21.734C44.1515 9.6969 34.0294 4.90942 27.0533 4.90942C20.0773 4.90942 9.81836 9.83369 9.81836 21.734Z",
    fill: "#E06621"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_5587_13299)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.7146 21.7341C5.7146 34.0995 17.0678 44.942 22.9496 49.0912C28.421 44.5772 40.0478 35.1938 40.0478 21.7341C40.0478 9.69703 29.9256 4.90955 22.9496 4.90955C15.9735 4.90955 5.7146 9.83381 5.7146 21.7341Z",
    fill: "#F260A7"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "27.2162",
    cy: "22.3065",
    fill: "white",
    r: "12.2423"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.9424 16.8099C26.5082 15.8298 27.9229 15.8298 28.4888 16.8099L34.0909 26.513C34.6568 27.4932 33.9494 28.7183 32.8177 28.7183H21.6135C20.4817 28.7183 19.7744 27.4932 20.3403 26.513L25.9424 16.8099Z",
    fill: "#F260A7"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.0621 24.5284C26.6156 24.5284 26.2539 24.1665 26.2537 23.72V20.4858C26.2537 20.0393 26.6156 19.6769 27.0621 19.6769C27.5087 19.6769 27.8705 20.0393 27.8705 20.4858V23.72C27.8704 24.1665 27.5086 24.5284 27.0621 24.5284Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.0585 26.8805C26.612 26.8805 26.2496 26.5187 26.2496 26.0721C26.2496 25.6255 26.612 25.2637 27.0585 25.2637H27.0663C27.5129 25.2637 27.8747 25.6255 27.8747 26.0721C27.8747 26.5187 27.5129 26.8805 27.0663 26.8805H27.0585Z",
    fill: "white"
  }));
}